import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form } from 'react-bootstrap';
// ;
import config from '../../config';
import { CSVLink } from "react-csv";
import BackButton from '../widgets/back_button';

export class ReporteConsumo extends Component {
    constructor(props) {
        super(props);
        //const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_ini: todayFormat,
            fecha_fin: todayFormat,
        }
    }

    updateReport = () => {
        const { fecha_ini, fecha_fin } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                fecha_ini,
                fecha_fin
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        fetch(config.servBackEnd + '/reports/reportcomfiar', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const info = data.data;
                    console.log(info);
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        return (
            <Fragment>

                <Jumbotron className="Jumbotron"><h2>Reporte Consumo Comfiar</h2></Jumbotron>
                <BackButton />
                <Row>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_ini: e.target.value })} value={this.state.fecha_ini} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_fin: e.target.value })} value={this.state.fecha_fin} />
                    </Col>
                    <Col>
                        <CSVLink data={info} filename={"reporte_consumo.csv"} separator={";"}>
                            <Button variant="success">Descargar Excel</Button>
                        </CSVLink></Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Genera Informe</Button>
                    </Col>
                </Row>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT</th>
                            <th>Razon Social</th>
                            <th>Factura</th>
                            <th>Nota C</th>
                            <th>Nota D</th>
                            <th>Documento S</th>
                            <th>NP</th>
                            <th>Nomina</th>
                            <th>Nomina Ajuste</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{element.ID_EMPRESA}</td>
                                        <td>{element.RAZON_SOCIAL}</td>
                                        <td>{element.FACTURA}</td>
                                        <td>{element.NOTA_C}</td>
                                        <td>{element.NOTA_D}</td>
                                        <td>{element.DOCUMENTO_S}</td>
                                        <td>{element.NOTA_NP}</td>
                                        <td>{element.NOMINA}</td>
                                        <td>{element.NOMINA_AJUSTE}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteConsumo



// WEBPACK FOOTER //
// ./src/components/reportes/reporteConsumo.jsx